<template>
  <div>
    <a-table bordered
            :loading="loading"
            :columns="columns"
            :data-source="userList"
            :pagination="pagination"
            @change="handleTableChange"
            >
      <template slot="headUrl" slot-scope="headUrl">
        <a-avatar shape="square" size="small" icon="user" :src="headUrl"/>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" v-if="hasPerm('/deviceuser/addDeviceuser')" class="margin-right-30" @click="openDevice(record)">授权</a>
        <a href="javascript:;" v-if="hasPerm('/user/find/user/des/')" class="margin-right-30" @click="lookUserInfo(record)">查看</a>
        <a href="javascript:;" v-if="hasPerm('/user/delete/user/')" style="color: #E84D11;" @click="delUser(record)">删除</a>
      </template>
    </a-table>
    <!-- 删除弹窗 -->
    <a-modal v-model="DELvisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <a-spin :spinning="DelSpinning">
        <div class="delUser">
          <div class="DelTitle">删除</div>
          <img src="~@/assets/image/common/DelHint.png" class="delIcon" alt="" />
          <div class="delHint">是否删除{{ DELuserName }}</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
            <a-button class="confirm" @click="confirm">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal v-model="userinfoVisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
            >
      <a-spin :spinning="infoSpinning">
        <div class="userInfo-title">用户详情</div>
        <a-form-model ref="userInfo" v-bind="layout" :model="userInfo" :rules="userInfoFormRules">
          <a-form-model-item has-feedback label="姓名" prop="nickname">
            <a-input v-model="userInfo.userName" type="text" autocomplete="off" :disabled="!btnShow" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="联系电话" prop="tel">
            <a-input v-model="userInfo.tel" type="text" autocomplete="off" :maxLength="11" :disabled="!btnShow" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="用户账号" prop="userName">
            <a-input v-model="userInfo.userUid" type="text" autocomplete="off" :disabled="true" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="登录密码">
            <a-input v-model="userInfo.password" type="text" autocomplete="off" placeholder="请输入密码" :disabled="!btnShow" />
          </a-form-model-item>
        </a-form-model>

        <div class="userInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="UserInfoCancel">取消</a-button>
          <a-button class="btn btn-active" v-if="!btnShow && hasPerm('/user/user/ids/')" @click="UserInfoEdit">修改</a-button>
          <a-popconfirm
            title="确定提交修改吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="confirmEdit('userInfo')"
            @cancel="cancel"
          >
            <a-button class="btn btn-active" v-if="btnShow" >提交</a-button>
          </a-popconfirm>
        </div>
      </a-spin>
    </a-modal>
    <!-- 关联设备 -->
    <a-modal v-model="deviceuserVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="deviceuserSpinning">
        <div class="userInfo-title">关联设备</div>
        当前用户姓名：
        <a-tag color="blue">
          {{user.userName}}
        </a-tag>
        账号：
        <a-tag color="blue">
          {{user.userUid}}
        </a-tag>
<!--        <span style="float: right;color: orange;">-->
<!--          提示：可以重复授权，已做去重处理-->
<!--        </span>-->
        <search @onSearch="onDeviceSearch" placeholder="请输入设备编码或IMEI搜索" style="margin:10px 0;" />
        <a-table bordered
                 :loading="deviceLoading"
                 :columns="deviceColumns"
                 :data-source="deviceList"
                 :pagination="devicePagination"
                 :row-selection="rowSelection"
                 @change="deviceHandleTableChange"
        >
        </a-table>

        <div class="userInfo-btn-wrap">


          <a-popconfirm
              title="确定全部授权吗？"
              ok-text="提交"
              cancel-text="取消"
              @confirm="allAuthorize"
          >
            <a-button class="btn cancel margin-right-30">全部授权</a-button>
          </a-popconfirm>

          <a-popconfirm
              title="确定全部解除吗？"
              ok-text="提交"
              cancel-text="取消"
              @confirm="unAllAuthorize"
          >
            <a-button class="btn btn-active">全部解除</a-button>
          </a-popconfirm>

          <a-button class="btn cancel margin-right-30" @click="deviceCancel">取消</a-button>

          <a-popconfirm
            title="确定提交授权吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="addDevice"
          >
            <a-button class="btn btn-active">授权</a-button>
          </a-popconfirm>


        </div>
      </a-spin>
    </a-modal>

  </div>
</template>

<script>
import { UserList, DelUser, UserInfo, upDataUserInfo } from "api/user";
import { DeviceList } from "api/device";
import {addDevice, allAuthorize, unAllAuthorize} from "api/deviceuser";
import search from "@/components/content/search/Search";
import {hasPermission} from 'utils/hasPermission'

const columns = [
  {title: "姓名", align: "center", dataIndex: 'userName'},
  {title: "微信名称", align: "center", dataIndex: 'nickName'},
  {title: '微信头像', align: "center", dataIndex: 'headUrl',scopedSlots: { customRender: 'headUrl' }},
  {title: '账号', align: "center", dataIndex: 'userUid'},
  {title: "手机号", align: "center", dataIndex: 'tel'},
  {title: '操作', align: "center",width: 200, dataIndex: 'operation',scopedSlots: { customRender: 'operation' }}
];
const deviceColumns = [
  {title: "设备id", align: "center", dataIndex: 'objectid'},
  {title: "设备编码", align: "center", dataIndex: 'vptNum'},
  {title: "IMEI", align: "center", dataIndex: 'name'},
];

export default {
  name: 'UserTable',
  components: {
    search
  },
  data() {
    let checkPending;
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('名字不能为空'));
      } else {
        callback();
      }
    };
    let validateUserUid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户账号不能为空'));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户密码不能为空'));
      } else {
        callback();
      }
    };
    return {
      columns,
      pagination: {
				defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },

      loading: false,
      DelSpinning: false,
      infoSpinning: false,

      pageIndex: 0,
	    pageSize: 10,
      userName: "",

      userList: [],

      DELvisible: false,
      DELuserName: "",
      DELuserId: Number,

      userinfoVisible: false,
      userInfo: {
        id: "",
        userName: "",
        tel: "",
        userUid: "",
        password: "",
      },
      userInfoFormRules: {
        userName: [{ validator: validateNickname, trigger: 'change'}],
        userUid: [{validator: validateUserUid, trigger: 'change'}],
        password: [{validator: validatePassword, trigger: 'change'}],
      },
      btnShow: false,

      //授权
      deviceuserVisible: false,
      deviceuserSpinning: false,
      deviceColumns,
      devicePagination: {
        defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.devicePagination.total} 条`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },
      deviceLoading: false,
      deviceList: [],
      devicePageIndex: 0,
      devicePageSize: 10,
      deviceName: "",
      user:"",
      //授权 选中参数
      selectedRowKeys:[],
      //授权 选中设备id
      objectids:[],
      //授权 关联表中的id
      selectedRowDUIds:[],

    };
  },
  computed: {
    rowSelection() {
      const {selectedRowKeys} = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectedRowKeys = selectedRowKeys;
          this.objectids = selectedRows.map((item)=>{
            return item.objectid
          })
        },
        // getCheckboxProps: record => ({
        //   props: {
        //     disabled: record.name === 'Disabled User',
        //     name: record.name,
        //   },
        // }),
      };
    },
  },
  mounted() {
    this.getUserListData(this.pageIndex, this.pageSize, this.userName)
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    //授权
    // 表格页面跳转
    deviceHandleTableChange(pagination, filters, sorter) {
      const pager = { ...this.devicePagination };
      console.log("pagination------------",pagination)
      pager.current = pagination.current;
      this.devicePagination = pager;
      this.devicePageIndex = pagination.current
      this.objectids = []
      this.selectedRowKeys = []
      this.selectedRowDUIds = []
      this.getDeviceListData(this.devicePageIndex, this.devicePageSize, this.deviceName)
    },
    getDeviceListData(pageIndex, pageSize, deviceName) {
      console.log("getDeviceListData==========",pageIndex, pageSize, deviceName)
      this.deviceLoading = true;
      DeviceList(pageIndex, pageSize, deviceName, this.user.id)
        .then(res => {
          console.log(res.data);
          if(res.data.rows.length > 0) {
            this.devicePagination.total = res.data.total;
            this.deviceList = res.data.rows;
            this.deviceLoading = false;
            let selectedRowKeys = []
            let objectids = []
            let selectedRowDUIds = []
            this.deviceList.forEach((item,index)=>{
              if (item.isAuthorize != null && item.isAuthorize != 'null'){
                selectedRowKeys.push(index)
                objectids.push(item.objectid)
                selectedRowDUIds.push(item.isAuthorize)
              }
            })
            this.selectedRowKeys = selectedRowKeys
            this.objectids = objectids
            this.selectedRowDUIds = selectedRowDUIds
            console.log('this.selectedRowKeys:', this.selectedRowKeys, 'this.objectids: ', this.objectids, 'this.selectedRowDUIds: ', this.selectedRowDUIds);
          } else {
            this.deviceLoading = false;
            this.devicePagination.total = 0;
            this.deviceList = []
            this.$message.error('没有查询到结果，请重试！');

          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
    },
    addDevice() {
      const vm = this;
      this.deviceuserSpinning = true
      addDevice(this.objectids,this.user.id,this.selectedRowDUIds)
        .then(res => {
          console.log(res);
          this.deviceuserSpinning = false
          if(res.code != "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success('设备关联成功！');
            // this.selectedRowKeys = []
          }
        })
        .catch(err => {
          vm.deviceuserSpinning = false
          console.log(err);
          this.$message.error(err.message);
        })
    },
    //全部授权
    allAuthorize(){
      const vm = this;
      this.deviceuserSpinning = true
      allAuthorize(this.user.id)
          .then(res => {
            console.log(res);
            this.deviceuserSpinning = false
            if(res.code != "0") {
              this.$message.error(res.message);
            } else {
              this.$message.success('全部授权成功！');
              // this.selectedRowKeys = []
            }
          })
          .catch(err => {
            vm.deviceuserSpinning = false
            console.log(err);
            this.$message.error(err.message);
          })
    },
    //全部解除
    unAllAuthorize(){
      const vm = this;
      this.deviceuserSpinning = true
      unAllAuthorize(this.user.id)
          .then(res => {
            console.log(res);
            this.deviceuserSpinning = false
            if(res.code != "0") {
              this.$message.error(res.message);
            } else {
              this.$message.success('全部解除成功！');
              // this.selectedRowKeys = []
            }
          })
          .catch(err => {
            vm.deviceuserSpinning = false
            console.log(err);
            this.$message.error(err.message);
          })
    },
    openDevice(record){
      this.user = record;
      this.objectids = []
      this.selectedRowKeys = []
      this.selectedRowDUIds = []
      this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
      this.deviceuserVisible = true;
    },
    // 搜索
    onDeviceSearch(value) {
      console.log(value)
      this.deviceName = value;
      this.devicePageIndex = 1;
      this.getDeviceListData(this.devicePageIndex, this.devicePageSize, this.deviceName)
    },
    // 取消
    deviceCancel() {
      this.deviceuserVisible = false;
      this.objectids = []
      this.selectedRowKeys = []
      this.selectedRowDUIds = []
    },




    /**
    *逻辑区
    */
    // 表格页面跳转
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pager.current - 1
      this.getUserListData(this.pageIndex, this.pageSize, this.userName)
    },
    // 删除
    delUser(record) {
      this.DELvisible = !this.DELvisible;
      this.DELuserName = record.userName,
      this.DELuserId = record.id
    },
    // 取消删除
    cancel() {
      this.DELvisible = !this.DELvisible;
    },
    // 查看用户信息
    lookUserInfo(record) {

      this.getUserInfo(record.id);
      this.userinfoVisible = true;
    },
    // 修改
    UserInfoEdit() {
      this.btnShow = true
    },
    // 取消
    UserInfoCancel() {
      this.userinfoVisible = false;
      this.btnShow = false;
      this.userInfo = {
        id: "",
        userName: "",
        tel: "",
        userUid: "",
        password: "",
      }
    },
    // 确定修改
    confirmEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.setEditUser(this.userInfo.id, this.userInfo.userName, this.userInfo.userUid, this.userInfo.password, this.userInfo.tel)
          this.btnShow = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //
    /**
    *逻辑区
    */
    getUserListData(pageIndex, pageSize, userName) {
      this.loading = true;
      UserList(pageIndex, pageSize, userName)
        .then(res => {
          console.log(res.data);
          if(res.data.rows.length > 0) {
            // let arr = [];
            this.pagination.total = res.data.total;
            // .forEach((item, index) => {
            //   let e = {
            //     key: index,
            //     id: Number,
            //     userName: "",
            //     tel: "",
            //     nickName:"",
            //     userUid:""
            //   };
            //   e.id = item.id;
            //   e.userName = item.userName;
            //   e.userUid = item.userUid;
            //   e.tel = item.tel;
            //   e.nickName = item.nickName;
            //   arr.push(e)
            // });
            this.userList = res.data.rows;
            this.loading = false;
          } else {
            this.loading = false;
            this.userList = []
            this.$message.error('没有查询到结果，请重试！');
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
    },
    // 确定删除
    confirm() {
      let that = this
      that.DelSpinning = true
      DelUser(this.DELuserId)
        .then(res => {
          console.log(res);
          that.$message.success(res.message);
          that.getUserListData(this.pageIndex, this.pageSize, this.userName);
          that.DelSpinning = false;
          that.DELvisible = false;
        })
        .catch(err => {
          console.log(err);
          that.DelSpinning = false;
          that.DELvisible = false;
          that.$message.error(err.message);
        })
    },
    // 查询用户信息
    getUserInfo(id) {
      this.infoSpinning = true;
      UserInfo(id)
        .then(res => {
          this.infoSpinning = false;
          console.log(res);
          const data = res.data;
          this.userInfo.id = data.id;
          this.userInfo.userName = data.userName;
          this.userInfo.tel = data.tel;
          this.userInfo.userUid = data.userUid;
        })
        .catch(err => {
          this.infoSpinning = false;
          console.log(err);
        })
    },
    // 修改用户信息
    setEditUser(id, userName, userUid, password, tel) {
      console.log(111);
      this.DelSpinning = true;
      upDataUserInfo(id, userName, userUid, password, tel)
        .then(res => {
          this.DelSpinning = false;
          console.log(res);
          this.$message.success(res.message);
          this.userinfoVisible = false
        })
        .catch(err => {
          this.DelSpinning = false;
          console.log(err);
          this.$message.error('请重试,修改失败');
        })
    },
    //数字格式化
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
  }
}
</script>

<style  lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delUser {
  text-align: center;
  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }
  .delHint {
    color: #212121;
    font-size: 36px;
    line-height: 90px;
  }
  .btn-wrap {
    text-align: center;
    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}
.userInfo-title {
  line-height: 10px;
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
}
.userInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;
  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
</style>
